export default __webpack_public_path__ + "static/media/elec.041427b7.jpg";